@if (!(isHomePage$ | async)) {
  <nav [attr.aria-label]="'common.breadcrumbs' | cxTranslate" tabindex="-1">
    <ol [attr.aria-label]="'common.breadcrumbs' | cxTranslate">
      @for (crumb of crumbs$ | async; track crumb) {
        <li>
        <a [attr.aria-label]="
            'navigation.navigateTo' | cxTranslate: { nav: crumb.label }
          " [routerLink]="crumb.link" [innerHTML]="crumb.label"></a>
        </li>
      }
    </ol>
  </nav>
  <span class="breadcrumb-h1">{{ title$ | async }}</span>
  <button class="custom-button-switch go-back" (click)="back()">
    <app-custom-icons [type]="iconTypes.ARROW_DOWN_ICON"></app-custom-icons>
  </button>
}